/** Marcador que ocupa el lugar de un puntaje ausente. */
export const NO_SCORE_LABEL = '—';

/** Decimales que se muestran en pantalla, sin importar los que devuelva la API. */
const SCORE_DECIMALS = 1;

/**
 * Único formateador de puntajes de la aplicación. El backend devuelve promedios con
 * cuatro decimales; imprimirlos crudos llenaba la pantalla de números como 3.3333.
 * Se conserva el decimal cero para que las columnas no cambien de ancho entre renders.
 */
export function formatScore(value: number | null | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return NO_SCORE_LABEL;
  return value.toFixed(SCORE_DECIMALS);
}
